<template>
  <div class="movingImage" ref="image"></div>
</template>

<script>
import * as PIXI from 'pixi.js';

export default {
  data: function() {
    return {
      image: null,
      canvas: null,
      displacementSprite: null,
      displacementFilter: null,
    };
  },
  props: {
    src: {
      type: String,
      required: true,
    },
    calibrations: {
      type: Object,
      required: false,
      default: () => {
        return { x: 8, y: 8 };
      },
    },
  },
  mounted() {
    this.initPixi();
    let self = this;
  },
  methods: {
    initPixi: function() {
      console.log({
        width: this.$refs.image.parentElement.clientWidth,
        height: this.$refs.image,
      });
      this.image = new PIXI.Application({
        width: this.$refs.image.clientWidth,
        height: this.$refs.image.clientHeight,
        // width: this.$refs.image.parentNode.clientWidth,
        // height: this.$refs.image.parentNode.clientHeight,
        transparent: true,
      });

      if (!this.$refs.image.querySelector('canvas')) {
        this.$refs.image.appendChild(this.image.view);
        this.canvas = this.$refs.image.querySelector('canvas');
      }

      let image = new PIXI.Sprite.from(this.src);
      image.width = this.$refs.image.clientWidth;
      image.height = this.$refs.image.clientHeight;
      //image.width = this.$refs.image.parentNode.clientWidth;
      // image.height = this.$refs.image.parentNode.clientHeight;
      this.image.stage.addChild(image);

      this.displacementSprite = new PIXI.Sprite.from(
        '/dist/images/header_slider/overlay.png'
      );
      this.displacementFilter = new PIXI.filters.DisplacementFilter(
        this.displacementSprite
      );
      this.displacementSprite.texture.baseTexture.wrapMode =
        PIXI.WRAP_MODES.REPEAT;
      this.image.stage.addChild(this.displacementSprite);
      this.image.stage.filters = [this.displacementFilter];

      this.displacementSprite.scale.x = this.calibrations.x;
      this.displacementSprite.scale.y = this.calibrations.y;
      this.animate();
    },
    animate: function() {
      this.displacementSprite.x += 10;
      this.displacementSprite.y += 4;

      //  this.displacementSprite.x += this.calibrations.x*1.25;
      //  this.displacementSprite.y += this.calibrations.y*0.5;

      requestAnimationFrame(this.animate);
    },
    click: function() {},
  },
};
</script>

<style lang="sass" scoped>
.movingImage
  position: absolute
  width: 100%
  height: 100%
  pointer-events: none
</style>



// WEBPACK FOOTER //
// src/templates/components/ui/movingimage.vue